import { DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

import { SharedCommonModule } from './shared-common.module';
import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';
import { ScrollableTableDirective } from './directives/scrollable-table.directive';
import { TooptipIfTruncatedDirective } from './directives/tooptip-if-truncated.directive';
import { DictionaryMapperComponent } from './dictionary-mapper/dictionary-mapper.component';
import { CommonUserMgmtComponent } from './user/common-user-management.component';
import { JhiAlertComponent } from './alert.component';
import { JhiAlertErrorComponent } from './alert-error.component';
import { NotificationComponent } from './notification/notification.component';
import { AlertComponent } from './alert/alert.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { DataLoadingComponent } from './data-loading/data-loading.component';
import { DialogCloseButtonComponent } from './dialog-close-button/dialog-close-button.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PageBodyComponent } from './page-body/page-body.component';
import { SubPageComponent } from './sub-page/sub-page.component';
import { PaginationComponent } from './pagination/pagination.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { NoPermissionErrorComponent } from './no-permission-error/no-permission-error.component';
import { NoDataJumbotronComponent } from './no-data-jumbotron/no-data-jumbotron.component';
import { JhiSortDirective } from './util/sort.directive';
import { JhiSortByDirective } from './util/sort-by.directive';
import { TooltipComponent } from './tooltip/tooltip.component';



@NgModule({
  imports: [
    TranslateModule.forChild(),
    SharedCommonModule
  ],
  declarations: [
    JhiAlertComponent,
    JhiAlertErrorComponent,
    JhiSortDirective,
    JhiSortByDirective,
    HasAnyAuthorityDirective,
    ScrollableTableDirective,
    TooptipIfTruncatedDirective,
    DictionaryMapperComponent,
    CommonUserMgmtComponent,
    AlertComponent,
    ButtonIconComponent,
    DataLoadingComponent,
    DialogCloseButtonComponent,
    NotificationComponent,
    PageHeaderComponent,
    PageBodyComponent,
    SubPageComponent,
    PaginationComponent,
    StatusBadgeComponent,
    NoPermissionErrorComponent,
    NoDataJumbotronComponent,
    TooltipComponent
  ],
  providers: [
    CookieService,
    DatePipe,
  ],
  exports: [
    SharedCommonModule,
    JhiAlertComponent,
    JhiAlertErrorComponent,
    JhiSortDirective,
    JhiSortByDirective,
    HasAnyAuthorityDirective,
    ScrollableTableDirective,
    TooptipIfTruncatedDirective,
    DictionaryMapperComponent,
    CommonUserMgmtComponent,
    AlertComponent,
    ButtonIconComponent,
    DataLoadingComponent,
    DialogCloseButtonComponent,
    NotificationComponent,
    PageHeaderComponent,
    PageBodyComponent,
    SubPageComponent,
    PaginationComponent,
    StatusBadgeComponent,
    NoPermissionErrorComponent,
    NoDataJumbotronComponent,
    TooltipComponent,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
